import React from "react";
// import { NavLink } from "react-router-dom";
// import Header from "../component/Header";
import Carousel from "../component/Carousel";
// import HomeAccordian from "../component/HomeAccordian";
import HomeFooterInfo from "../component/HomeFooterInfo";

import HomeConsultant from "../component/HomeConsultant";

import HomeTestimonials from "../component/HomeTestimonials";
import HomeMarquee from "../component/HomeMarquee";
import HomeServices from "../component/HomeServices";
import HomePageOffers from "../component/HomePageOffers";
// import HomeUserReview from "../component/HomeUserReview";
import ScrollButton from "./ScrollButton";
import BasicSpeedDial from "./BasicSpeedDial";
import OurProducts from "./OurProducts";
import OurServicesConsultant from "./OurServicesConsultant";
// import WRTCHomePage from "./WRTCHomePage";
import HelmetSeo from "../component/HelmetSeo";
import HomeClickAstro from "../component/HomeClickAstro";

const Home = () => {
  return (
    <React.Fragment>
      <HelmetSeo
        title="Vasthuparam - Free Online Astrology Consultation"
        name="description"
        content="Are you searching for good astrology consultation @online. Benefit from over 15 years of expertise in Vedic astrology to gain insights into your life."
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/"
      />
      {/* <Helmet>
        <title>Vasthuparam - Free Online Astrology Consultation</title>
        <meta name="description" content="aboutus vasthuparam" />
      </Helmet> */}
      {/* <Header breakpionts="lg" /> */}
      <HomeMarquee />
      <Carousel />
      {/* <WRTCHomePage /> */}
      <HomeServices />
      <HomePageOffers />
      {/* <OurServicesConsultant /> */}
      <HomeConsultant />
      {/* <HomeServicePlans /> */}
      <OurProducts />

      <HomeTestimonials />
      {/* <HomeUserReview /> */}
      {/* <HomeTestimonials />
    
      <HomeAccordian /> */}
      <HomeFooterInfo />
      <div
        style={{
          position: "fixed",
          top: "75%",
          width: "100%",
          height: "100%",
        }}
      >
        <HomeClickAstro />
        <div
          style={{
            float: "right",
            padding: "7px",
            borderRadius: "7px",
            marginRight: "5px",
          }}
        >
          {/* <FiPhoneCall />+919025028213 */}
          <div className="d-none d-lg-inline">
            <BasicSpeedDial />
          </div>
          <ScrollButton />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Home;
